import classes from './RadioInput.module.css'

const RadioInput = ({
  children,
  value,
  selectedValue,
  required,
  name,
  change,
}) => {
  return (
    <>
      <label
        className={`${classes.label} relative block px-2 mx-3.5 my-4 font-[sans-serif]`}
      >
        <input
          className={`${classes.input} opacity-0 absolute pointer-events-none`}
          type="radio"
          value={value}
          required={required}
          name={name}
          checked={value == selectedValue}
          onChange={change}
        />
        <div
          className={`${classes.radioInput} ${
            value === selectedValue ? classes.is_checked : ''
          }`}
        ></div>
        <span className="text-darkGray text-base align-middle ml-2 font-[sans-serif]">
          {children}
        </span>
      </label>
    </>
  )
}

export default RadioInput
